import API from '../utils/api';
import { device_URI } from '../constants/defaultValues';

const getDeviceMacAddress = async () => {
    try {
        const res = await API.get(`${device_URI}/api/device/mac-address`);

        return res.data;
    } catch (error) {
        console.error(error);
    }
};

const DeviceService = {
    getDeviceMacAddress,
};

export default DeviceService;
